import { render } from "./ReceiverRemovalConfirmationDialog.vue?vue&type=template&id=2ecec184"
import script from "./ReceiverRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ReceiverRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__